document.addEventListener('DOMContentLoaded', function() {

    const header = document.querySelector('#site-header');

    const tabLinks = document.querySelectorAll('.megamenu [data-bs-toggle="pill"]');
    tabLinks.forEach(tabLink => {
        tabLink.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            const target = this.getAttribute('href');
            const tab = new bootstrap.Tab(target);

            tab.show();
        });
    });

    // Find all megamenus first, then get their parent dropdowns
    const megamenus = document.querySelectorAll('.megamenu');
    megamenus.forEach(megamenu => {
        const dropdown = megamenu.closest('.dropdown');
        if (dropdown) {
            dropdown.addEventListener('show.bs.dropdown', () => {
                header.classList.add('scheme-2');
            });
        }
    });
});